<template>
  <div>
    <el-dialog title="选择机构组织"
               top="5px"
               :width="dialogWidth"
               :visible.sync="visible"
               :before-close="handleClose"
               :show-close="true"
               @opened="openedDialog"
               center
               append-to-body>
      <el-container>
        <el-aside width="180px"
                  style="height:100%;min-height:550px;border-right: 1px solid rgb(181, 181, 181);">
          <templateTag ref="templateTag"
                       @openSearch="openSearch3"
                       style="height: 100%;background-color: #ffffff;"
                       @getAllTask="getAllTask"
                       class="templateTag fl"
                       :indexTit="templateTitle"
                       :columns="columns"></templateTag>
        </el-aside>
        <el-container>
          <el-header height="30px">
            <el-row >
              <el-col :span="3" :offset="15" >
               <el-button @click="searchDeviceObject"   size="mini" type="primary">精确搜索</el-button>
              </el-col>
              <el-col :span="6">
                <el-input placeholder="请输入关键字"
                style="width:90%"
                          @keyup.enter="searchIns"
                          v-model="filterText"
                          size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="searchIns"></el-button>
                </el-input>
              </el-col>
            </el-row>
          </el-header>
          <el-main>
            <el-row style="border-top:1px solid #B5B5B5;">
              <el-col :span="leftCol"
                      style="text-align: center;">
                <div style="height:500px;"
                     v-loading="loading">
                  <el-scrollbar style="height: 100%;">
                    <el-tree class="filter-tree"
                             :data="data"
                             :props="defaultProps"
                             @node-click="handleNodeClick"
                             accordion
                             default-expand-all
                             :expand-on-click-node="false"
                             :check-strictly="true"
                             :default-checked-keys="expandedKeys"
                             :show-checkbox="!isStrictly"
                             node-key="InsId"
                             rowKey="InsId"
                             :filter-node-method="filterNode"
                             @check-change="checkChange"
                             highlight-current
                             ref="insTree">
                      <span class="custom-tree-node"
                            slot-scope="{ node, data }">
                        <span style="padding-bottom: 0px;"
                              v-on:dblclick="dblclickToSure(data)">{{ node.label }}</span>
                      </span>
                    </el-tree>
                  </el-scrollbar>
                </div>
              </el-col>
              <el-col :span="rightCol"
                      style="text-align: center;border-left:1px solid #B5B5B5;height: 500px;">
                <div v-if="showRightCol&&!expand">
                  <div style="padding: 8px 0px 10px 0px;background-color: rgb(215, 215, 215)">
                    <span style="font-size: 18px;">选中数据</span>
                  </div>
                  <div>
                    <el-table 
                              :data="resultList"
                              :show-header="false"
                              row-key="InsId"
                              height="445px"
                              style="width: 100%"
                              header-align="center"
                              highlight-current-row
                              @current-change="handleCurrentChange">
                      <!-- <el-table-column label="名称">
                        <template slot-scope="scope">
                          <div slot="reference">
                            <el-tag effect="plain"
                                    closable
                                    @close="deleteClick(scope.$index, scope.row)">{{ scope.row.Name }}</el-tag>
                            <el-button style="padding:2px;margin-left:2px"
                                       type="danger"
                                       size="mini"
                                       icon="el-icon-close"
                                       @click="deleteClick(scope.$index, scope.row)"
                                       circle></el-button> 
                          </div>
                        </template>
                      </el-table-column> -->
                      <el-table-column
                        v-for="(column, index) in columns"
                        :key="index"
                        :prop="column.value"
                        :label="column.text"
                        :width="column.width"
                      ></el-table-column>
                      
                      <el-table-column label="操作" width="50px">
                          <template slot-scope="scope">
                            <el-button title="删除"  icon="el-icon-close" circle size="small" type="danger" @click="handleDelete(scope.$index,scope.row)"></el-button>
                          </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div style="text-align: center;">
                    <el-button type="primary"
                              size="medium"
                              style="width:80px;padding:7px;margin-right:10px;"
                              @click="toSure('')">确认返回</el-button>
                    <!-- <el-button size="mini"
                              style="padding:7px"
                              icon="el-icon-circle-check-outline"
                              @click="saveClick">存为模板</el-button> -->
                    <el-button type="info" size="medium"
                              style="width:80px;padding:7px;margin-left:10px;"
                              @click="toCloseForm">清空</el-button>
                </div>

                <!-- <el-button type="primary"
                             size="mini"
                             icon="el-icon-circle-close-outline"
                             @click="deleteClick"
                             round>删除</el-button> -->
                <createTemplate ref="createTemplate"
                                :body="false"
                                :temType="1"></createTemplate>
              </el-col>
            </el-row>
          </el-main>
          <!-- <el-footer v-show="isRadio">
            <div style="text-align: center;">
              <el-button @click="toCloseForm">清空</el-button>
              <el-button type="primary"
                         @click="toSure('')">确认返回</el-button>
            </div>
          </el-footer> -->
        </el-container>
      </el-container>
    </el-dialog>
    <userSearchDialog ref="userSearch"
                      :searchMethod="SearchAsync"></userSearchDialog>
  </div>
</template>

<script>
import templateTag from "../template/templateTag.vue";
import userSearchDialog from "@/components/basicTemplate/userSearchDialog.vue";
import { listToTree } from "@/api/modules/basicData/commonData";
import createTemplate from "../template/createTemplate.vue";
import {
  GetTemplateCompanyDeptSearchResult,
  GetTemplateCompanyDeptSearchByTemplateID,
  GetTemplateUserSearchResultByTemplateID
} from "@/api/modules/basicData/organization";
import { getToken } from "@/util/auth";
import { mapState, mapMutations, mapGetters } from "vuex";
import { UpdateTemplate } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  name: "InstitutionDialog",
  components: {
    templateTag,
    userSearchDialog,
    createTemplate
  },
  props: {
    isRadio: Boolean
  },
  data() {
    return {
      visible: false,
      data: [],
      treeList: [],
      insList: [],
      loading: false,
      templateTitle: "机构组织面板管理",
      columns: [
        {
          text: "名称",
          value: "Name"
        }
      ],
      selectedIns: [],
      tableData: [],
      dialogWidth: "1000px",
      filterText: "",
      leftCol: 15,
      rightCol: 9,
      defaultProps: {
        id: "ID",
        children: "children",
        label: "Name"
      },
      isStrictly: false,
      expandedKeys: [],
      showRightCol: true,
      expand: false,
      editCheckIdArr: [],
      unverifiedSelectedIns: []
    };
  },
  watch: {
    filterText(val) {
      this.debouncedSearch(val);
    }
  },
  computed: {
    ...mapState({
      resultList: state => state.resultBase.resultList,
      resultSelection: state => state.resultBase.resultSelection,
      isResult: state => state.resultBase.isResult,
      tagItem: state => state.task.tagItem,
      resultTagItem: state => state.task.resultTagItem
    })
  },
  methods: {
    
    openDialog(selectedIns) {
      this.reset();
      this.getTreeData(selectedIns);
      this.$store.state.template.category = 13;
      this.$store.state.template.isLookRecord = false;
      this.visible = true;
    },
    searchDeviceObject() {
      this.openSearch3();
    },
    getTreeData(selectedIns) {
      let insParas = {
        CurrentUserId: cookieUser.userId,
        Keyword: ""
      };
      this.GetTemplateCompanyDeptSearchResult(insParas, true, selectedIns);
    },
    openSearch3(data) {     //打开精确搜索
      console.log("打开精确搜索",data);
      this.$refs.userSearch.SearchOpen(data);
    },
    SearchAsync(userPara) {
      //获取团队数据
      this.GetTemplateUserSearchResult(userPara);
      this.$refs.userSearch.userSearchDialog = false;
    },
    getAllTask(data) {
      if (data.TEMPTYPE == 0) {
      } else if (data.TEMPTYPE == 1) {
        this.GetTemplateCompanyDeptSearchByTemplateID(data.ID);
      }
    },
    GetTemplateCompanyDeptSearchResult(insParas, isFirst, selectedIns) {
      (this.loading = true),
        GetTemplateCompanyDeptSearchResult(insParas).then(response => {
          // 接口返回Id，组件使用ID
          response.forEach(_res => {
            // Type-SocialId是标识，ID是组件中使用到的
            _res.InsId = _res.Type + "_" + _res.SocialId;
            _res.ID = _res.Id;
          });
          this.treeList = response;
          this.data = listToTree("Id", "Pid", Object.assign([], response));
          if (isFirst) {
            this.insList = response;

            this.selectedIns = selectedIns;
            this.tableData = [];
            (this.editCheckIdArr = []),
              this.selectedIns.forEach(c => {
                let _item = Object.assign({}, c);
                _item.children = [];
                _item.InsId = _item.Type + "_" + _item.SocialId;
                this.tableData.push(_item);
                this.editCheckIdArr.push(_item.InsId);
                // this.checkAllTree(_item.InsId, true);
                for (var i = 0; i < this.treeList.length; i++) {
                  if (this.treeList[i].InsId == _item.InsId) {
                    let tree = this.$refs.insTree;
                    let insId = this.treeList[i].InsId;
                    setTimeout(() => {
                      tree.setChecked(insId, true);
                    }, 200);
                  }
                }
              });
          }
          this.loading = false;
        });
    },
    GetTemplateCompanyDeptSearchByTemplateID(templateId) {
      (this.loading = true),
        GetTemplateCompanyDeptSearchByTemplateID(templateId).then(response => {
          response.forEach(_res => {
            // Type-SocialId是标识，ID是组件中使用到的
            _res.InsId = _res.Type + "_" + _res.SocialId;
            _res.ID = _res.Id;
          });
          this.treeList = response;
          this.data = listToTree("Id", "Pid", Object.assign([], response));
          if (response.length > 0) {
            this.$store.commit("setResult", response); //  右侧结果集赋值
            this.$store.state.resultBase.isResult = true; //判断当前是否点击结果集
          }
          this.loading = false;
        });
    },
    handleClose(done) {
      done();
    },
    //打开弹出框完成后回调，已有数据赋值
    openedDialog() {
      this.$refs.templateTag.getLeftAndAll();
    },
    searchIns() {
      this.getKeywordIns(this.filterText);
    },
    getKeywordIns(keyword) {
      if (keyword !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          keyword = keyword.toLowerCase();
          let res = this.insList.filter(item => {
            return (
              item.Name.toLowerCase().indexOf(keyword) > -1 ||
              item.PY.toLowerCase().indexOf(keyword) > -1 ||
              item.FullPY.toLowerCase().indexOf(keyword) > -1
            );
          });
          this.data = listToTree("Id", "Pid", res);
        }, 200);
      } else {
        this.data = listToTree("Id", "Pid", this.insList);
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
    handleNodeClick(item, node, self) {
      if (!this.isRadio) {
        return;
      }
      this.dataForIsRadio = item;
      let _item = Object.assign({}, item);
      _item.children = [];

      if (this.resultList.findIndex(i => i.InsId == _item.InsId) == -1) {
        item.treeType = _item.treeType = 0;
        this.tableData.push(_item);
        //点击未选中复选框
        this.$store.commit("addResult", {
          row: _item,
          bol: true
        });
      }
    },
    dblclickToSure(data) {
      if (this.isRadio == true) {
        this.toSure(data);
      }
    },
    toSure(data) {
      this.userName = "";
      if (this.isRadio == true) {
        this.unverifiedSelectedIns = [this.$refs.insTree.getCurrentNode()];
      } else {
        this.unverifiedSelectedIns = [];
        this.tableData.forEach(c => {
          this.unverifiedSelectedIns.push(c); //存入未验证数组
        });
      }
      if (this.transferValue(this.unverifiedSelectedIns) == true) {
        this.toClose();
        this.visible = false;
      }
      if (!this.selectedIns) this.selectedIns = [];
      this.$emit("assignmentInput", this.selectedIns);
    },
    transferValue(unverifiedData) {
      let isValidate = true; //验证是否通过
      this.$emit("getValue", unverifiedData, function(str) {
        //传递值，无论是否验证
        isValidate = str;
      });
      if (isValidate) {
        //验证通过
        //内外公共操作一起处理
        this.selectedIns = [];
        unverifiedData.forEach(c => {
          //   let validType = [1, 2, 3];
          //   if (validType.indexOf(c.Type) > -1) {
          //     this.selectedIns.push(c);
          //   }
          this.selectedIns.push(c);
        }); //最终值进行处理
        return true;
      } else {
        //验证不通过
        this.unverifiedSelectedIns = [];
        return false;
      }
    },
    toClose() {
      //关闭弹窗前操作
      this.dataForIsRadio = {};
      this.filterText = "";
      this.editCheckId = "";
      this.tableData = [];
      this.$refs.insTree.setCheckedKeys([]);
    },
    checkAllTree(code, trueOrFalse) {
      for (var i = 0; i < this.treeList.length; i++) {
        if (this.treeList[i].InsId == code) {
          this.$refs.insTree.setChecked(this.treeList[i].InsId, trueOrFalse);
        }
      }
    },
    checkChange(item, node, self) {
      //勾选
      if (this.isRadio == true) {
      } else {
        let _item = Object.assign({}, item);
        _item.children = [];
        //结果集
        if (node == true) {
          //点击未选中复选框
          this.$store.commit("addResult", {
            row: _item,
            bol: true
          });
        } else {
          this.$store.commit("addResult", {
            row: _item,
            bol: false
          });
        }

        if (node == true) {
          //点击未选中复选框
          if (this.editCheckIdArr.indexOf(item.InsId) == -1) {
            //不包含该元素
            this.editCheckIdArr.push(item.InsId);
            item.treeType = 0;
            this.tableData.push(_item);
            this.checkAllTree(item.InsId, true);
          }
        } else {
          //已选中
          this.checkAllTree(item.InsId, false);
          this.updateTable(item.InsId);
        }
      }
    },
    handleDelete(index, row) {
      this.updateTable(row.InsId);
      var temporaryTreeArr = this.$refs.insTree.getCheckedNodes();
      for (var i = 0; i < temporaryTreeArr.length; i++) {
        if (temporaryTreeArr[i].InsId == row.InsId) {
          //如果ID一样视为同一人，取消选中
          this.$refs.insTree.setChecked(temporaryTreeArr[i].InsId, false);
        }
      }
    },
    updateTable(code) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].InsId == code) {
          this.tableData.splice(i, 1);
          this.editCheckIdArr.splice(i, 1);
        }
      }
    },
    toCloseForm() {
      this.dataForIsRadio = {};
      this.filterText = "";
      this.editCheckId = "";
      this.editCheckIdArr = [];
      this.tableData = [];
      this.$refs.insTree.setCheckedKeys([]);
    },
    DetailsEvent(row) {},
    operationPanel() {
      //操作结果库面板是否显示
      if (this.expand) {
        this.expand = false;
        if (this.isRadio == true) {
          this.isStrictly = true;
          // this.leftCol = 24;
          // this.rightCol = 0;
          this.leftCol = 17;
          this.rightCol = 7;
          // this.showRightCol = false;
        }
      } else {
        this.expand = true;
        if (this.isRadio == true) {
          this.leftCol = 17;
          this.rightCol = 7;
          this.isStrictly = false;
          // this.showRightCol = true;
        }
      }
      console.log("结果集:", this.expand);
    },
    GetTemplateUserSearchResultByTemplateID(templateId) {
      (this.loading = true),
        GetTemplateUserSearchResultByTemplateID(
          templateId,
          cookieUser.userId
        ).then(response => {
          this.treeList = response;
          this.data = listToTree("Id", "Pid", Object.assign([], response));
          if (response.length > 0) {
            this.$store.commit("setResult", response); //  右侧结果集赋值
            this.$store.state.resultBase.isResult = true; //判断当前是否点击结果集
          }
          this.loading = false;
        });
    },
    redact(val) {
      // 编辑模板
      if (val.TEMPTYPE == 1) {
        GetTemplateUserSearchResultByTemplateID(val.CONTENT).then(res => {
          this.$store.state.template.tableData = res;
        });
      } else {
        let content = JSON.parse(val.CONTENT);
        this.$store.commit("setQueryTask", content);
      }
    },
    checkSource() {
      if (this.isRadio == true) {
        this.isStrictly = true;
        // this.leftCol = 24;
        // this.rightCol = 0;
        this.leftCol = 17;
        this.rightCol = 7;
        // this.showRightCol = false;
      } else {
      }
    },
    reset() {
      this.userName = "";
      this.tableData = [];
      this.dataForIsRadio = {};
      this.editCheckIdArr = [];
      this.selectedData = []; //初始值
      this.selectedIns = []; //最终值
      this.unverifiedSelectedIns = []; //待验证值
      this.$store.commit("clearResult");
      // this.$emit("getValue", this.selectedIns, function(str) { //传递值，无论是否验证
      //     console.log('清理完成')
      // });
    },
    saveClick() {
      let idArr = [];
      this.resultList.forEach(item => {
        idArr.push({
          ID: item.SocialId,
          Type: item.Type
        });
      });
      if (this.isResult) {
        this.$confirm("请选择", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "创建新模板", //确定
          cancelButtonText: "保存到原模板", //删除
          type: "warning"
        })
          .then(() => {
            this.$refs.createTemplate.open();
            // this.$refs.createTemplate.userId = this.userId;
            this.$refs.createTemplate.content = JSON.stringify(idArr);
          })
          .catch(action => {
            if (action === "cancel") {
              let obj = this.resultTagItem;
              obj.CONTENT = JSON.stringify(idArr);
              console.log(obj, "obj");
              // return false
              UpdateTemplate(obj, this.category).then(res => {
                console.log(res);
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功"
                  });
                }
              });
            }
          });
      } else {
        this.$refs.createTemplate.open();
        this.$refs.createTemplate.content = JSON.stringify(idArr);
      }
    },
     deleteRow(index,rows){  //删除图标对应的当前行
      console.log(index);
      console.log(rows);
      rows.splice(index, 1);
    },
    deleteClick(index, row) {
      //删除当前行
      // if (!this.resultSelection) {
      //   this.$message({
      //     type: "info",
      //     message: "请选择需要删除行"
      //   });
      //   return;
      // }
      this.$store.commit("setResultSelection", row);
      this.$store.commit("deleteResult", this.resultSelection.ID);
      if (this.resultList.length == 0) {
        this.$store.state.resultBase.isResult = false;
      }
      this.$refs.insTree.setChecked(this.resultSelection.InsId, false);
    },
    handleCurrentChange(row) {
      //当前行事件
      // console.log('当前：', row);
      // this.nowRow = row;
      this.$store.commit("setResultSelection", row);
    }
  },
  created() {
    let _ = require("lodash");
    this.debouncedSearch = _.debounce(this.getKeywordIns, 1000);
    this.checkSource();
  },
  mounted() {
    this.$root.$on("amendSearch", data => {
      this.redact(data);
    });
    // 初始状态，展示所有结果
    let insParas = {
      CurrentUserId: cookieUser.userId,
      Keyword: "",
      Phone: ""
    };
    this.GetTemplateCompanyDeptSearchResult(insParas);
  }
};
</script>

<style scoped>
</style>
